// ✅ Export par défaut d'un composant fonctionnel
export default function BackgroundVideo() {
  return (
    <video
      className="bg-video"
      autoPlay
      muted
      loop
      playsInline
      preload="auto"
      poster="/videos/security-bg.jpg"
      aria-hidden="true"
    >
      <source src="/videos/security-bg.webm" type="video/webm" />
      <source src="/videos/security-bg.mp4" type="video/mp4" />
    </video>
  );
}
